
import StoryblokComponent from '~/components/Storyblok/Component'

export default {
  components: {
    StoryblokComponent,
  },
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showModal: false,
      scrollToNext: 'section-0',
      arrowTl: null,
      isScrolling: false,
      stopScroll: null,
      startScroll: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      // the road asset color sequence is a tiny bit faster than the others
      // slowing it down to match speeds
      // this.$refs.road.playbackRate = 0.99

      this.setScrollEventListeners()

      const mm = this.$gsap.matchMedia(this.$el)

      this.initParallax()

      // desktop
      mm.add('(min-width: 1024px)', () => {
        this.setupAnimation()
        this.setFadeInScrolltriggers()
        this.setPinnedSectionScrollTriggers()
      })
    })
    window.addEventListener('message', this.hubSpotEventHandler)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.hubSpotEventHandler)
    window.removeEventListener('scroll', this.stopScroll)
    window.removeEventListener('scroll', this.startScroll)
  },
  methods: {
    setupAnimation() {
      this.$gsap.set(this.$refs.content, {
        scale: 0.9,
      })

      // reveal the content
      this.$gsap.to(this.$refs.content, {
        scale: 1,
        // scale: 0.5,
        duration: 0.7,
        onComplete: () => {
          // set
          const tl = this.$gsap.timeline({
            scrollTrigger: {
              trigger: this.$refs.content,
              start: 'top top',
              end: 'bottom top+=10%',
              // pin: this.$refs.content,
              scrub: 1,
              // markers: true,
            },
          })
          tl.to([this.$refs.content], {
            opacity: 0,
            duration: 2,
          })
        },
      })

      // bounce arrow
      this.$gsap.to(this.$refs.downArrow, {
        duration: 0.6,
        y: 10,
        ease: 'circ.in',
        repeat: -1,
        yoyo: true,
      })

      this.arrowTl = this.$gsap
        .timeline({
          paused: true,
        })
        .to(this.$refs.downArrow, {
          rotate: 180,
          duration: 0.5,
          ease: 'back(.5)',
        })
    },

    setPinnedSectionScrollTriggers() {
      this.$gsap.timeline({
        scrollTrigger: {
          trigger: '.pinned-section',
          start: 'top top',
          end: 'bottom bottom',
          pin: '.pin-left',
          // markers: true,
        },
      })
    },

    initParallax() {
      this.$gsap.set('#video-sky', {
        scale: 1,
      })

      const tl = this.$gsap.timeline({
        scrollTrigger: {
          trigger: this.$refs.container,
          start: 'top top',
          end: 'bottom top',
          scrub: true,
        },
      })

      // parallax
      this.$gsap.utils.toArray('.parallax').forEach((layer) => {
        const depth = layer.dataset?.depth
        const movement = -(layer.offsetHeight * depth)
        tl.to(layer, { y: movement, ease: 'none' }, 0)

        // scale the sky to fill the screen
        if (layer.id === 'video-sky') {
          tl.to(layer, { scale: 1.6, ease: 'none' }, 0)
        }
        // scale the forground
        if (layer.id === 'video-forground') {
          tl.to(layer, { scale: 1.2, ease: 'none' }, 0)
        }
      })
    },

    setFadeInScrolltriggers() {
      this.$gsap.set(['.conference-section', this.$refs.logo], {
        opacity: 0.3,
      })

      const sections = this.$gsap.utils.toArray('.conference-section')

      sections.forEach((section, i) => {
        const tl = this.$gsap.timeline({
          scrollTrigger: {
            trigger: section,
            start: 'center 100%',
            end: 'center 0%',
            scrub: true,
            // markers: true,
            onUpdate: (self) => {
              // scrolling down
              if (self.direction === -1 && self.progress < 0.5) {
                if (self.trigger?.dataset?.target === 'section-' + i) {
                  // scroll to current section - user is scrolling down but not yet reached middle of section
                  this.scrollToNext = 'section-' + i

                  // always flip arrow down
                  this.arrowTl.reverse()
                }

                // if (self.trigger?.dataset?.target === 'section-0') {
                //   this.scrollToNext = 'section-0'
                //   this.arrowTl.reverse()
                // }

                // if (self.trigger?.dataset?.target === 'section-1') {
                //   this.scrollToNext = 'section-1'
                //   this.arrowTl.reverse()
                // }
              }

              // scrolling up
              if (self.direction === 1 && self.progress >= 0.49) {
                if (self.trigger?.dataset?.target === 'section-' + i) {
                  if (i === sections.length - 1) {
                    // if last - set next target to container (top of page)
                    this.scrollToNext = 'container'
                    // flip arrow up
                    this.arrowTl.play()
                  } else {
                    // set next section
                    this.scrollToNext = 'section-' + (i + 1)
                    // flip arrow down
                    this.arrowTl.reverse()
                  }
                }

                // if (self.trigger?.dataset?.target === 'section-0') {
                //   this.scrollToNext = 'section-1'
                //   this.arrowTl.reverse()
                // }

                // if (self.trigger?.dataset?.target === 'section-1') {
                //   this.scrollToNext = 'container'
                //   this.arrowTl.play()
                // }
              }
            },
          },
        })
        tl.to([section], {
          opacity: 1,
          duration: 2,
        })

        if (sections.length - 1 !== i) {
          tl.to(section, { opacity: 0.3, duration: 2 }, 2)
        }
      })

      // pinned logo scroll trigger: opactiy
      const tl = this.$gsap.timeline({
        scrollTrigger: {
          trigger: this.$refs.logo,
          start: 'bottom 100%',
          end: 'bottom center',
          scrub: 0.5,
          // markers: true,
        },
      })
      tl.to([this.$refs.logo], {
        opacity: 1,
        duration: 2,
      })
    },

    setScrollEventListeners() {
      this.stopScroll = this.$debounce(() => {
        // console.log('stop')
        this.isScrolling = false
      }, 100)
      this.startScroll = this.$debounce(() => {
        if (!this.isScrolling) {
          // console.log('start')
          this.isScrolling = true
        }
      }, 0)

      window.addEventListener('scroll', this.stopScroll)
      window.addEventListener('scroll', this.startScroll)
    },

    scrollTo() {
      // prevent click if already scrolling
      // prevents conflicting scroll triggers
      if (this.isScrolling) return

      // scroll to next section
      this.$gsap.to(window, {
        duration: 1,
        scrollTo: {
          y: this.$refs[this.scrollToNext],
          offsetY: -10,
        },
      })
    },

    hubSpotEventHandler(event) {
      if (
        event.data.type === 'hsFormCallback' &&
        event.data.eventName === 'onFormSubmitted'
      ) {
        if (event.data.id === this.blok.form[0].form_id) {
          setTimeout(() => {
            this.closeModal()
          }, this.blok.modal_timeout || 3000)
        }
      }
    },
    openModal() {
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
    },
  },
}
